import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import {Platform} from '@angular/cdk/platform';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {

  iosCheck:boolean = false;
  public customer:boolean;
  org;
  user:any=[];
  Menu:any=[];
  vendorApp;
  constructor(public menu: MenuController, 
              public auth: AuthService, 
              public platform: Platform,
              public router:Router,
              public handler: HandlerService) { 
               
      if(this.platform.IOS){
        this.iosCheck = true;
      }    
  }

  ionViewWillEnter(){
    this.vendorApp = sessionStorage.getItem('vendorApp');
   
  }

  ngDoCheck(): void {
    this.vendorApp = sessionStorage.getItem('vendorApp');
   
  }

  check(data) {  
    if (data.name == 'Logout') {
      this.logout()
    }
    else {
      this.router.navigateByUrl(data.route)
    }
  }

    
  logout() {
    let post ={
       "userId": localStorage.getItem('currentUserId')       }
        this.auth.LogOut(post).subscribe(res => {
        localStorage.clear();
        sessionStorage.clear();  
        this.handler.res('Thank You Visit Again !!')
        this.router.navigate(['/vendor-register']);
      }, err => {
        this.handler.err(err);
        localStorage.clear(); 
        sessionStorage.clear();
        this.router.navigate(['/vendor-register']);
      })       

}
 

}